import { render, staticRenderFns } from "./IconSubjects.vue?vue&type=template&id=bf390890&"
import script from "./IconSubjects.vue?vue&type=script&lang=js&"
export * from "./IconSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports